import { useEffect, useState } from "react";
import SharedTable from "../../shared/sharedTable";
import { formatToLocalDate } from '../../helper/utils';
import DeleteSvg from "../../assets/svg/deleteSvg";
import EditSvg from "../../assets/svg/editSvg";
import { toast } from "react-toastify";
import ExportApi from "../../api/ExportApi";
import { Pagination, Row, Col, Form, Button } from "react-bootstrap";
import CustomModal from "../../shared/CustomModal";
import { useSelector } from "react-redux";
import PriceAlertModalContent from "./priceAlertModal";

const ManageAlertsDashBoard = () => {

    const columns = [
        {
            name: "Date",
            key: "createdAt",
            render: (row) => {
                return (
                    <div style={{ minWidth: "100px" }}> {formatToLocalDate(row?.createdAt) ?? "-"}</div>
                )
            }
        },
        {
            name: "Series",
            key: "series",
            render: (row) => {
                return (
                    <div > {row?.series ?? "-"}</div>
                )
            }
        },
        {
            name: "Model",
            key: "model",
            render: (row) => {
                return (
                    <div > {row?.model ?? "-"}</div>
                )
            }
        },
        {
            name: "Price",
            key: "price",
            render: (row) => {
                return (
                    <div > {row?.price ? `$${row?.price}` : "-"}</div>
                )
            }
        },
        {
            name: "Actions",
            key: "action",
            render: (row) => {
                return (
                    <div className="d-flex flex-row gap-3">
                        <span onClick={() => {
                            setManageAlertsModal(false)
                            setDeleteAlert(null)
                            setEditAlert(row)
                        }} style={{ cursor: "pointer" }}>
                            <EditSvg />
                        </span>
                        <span onClick={() => {
                            setManageAlertsModal(false)
                            setEditAlert(null)
                            setDeleteAlert(row?._id)
                        }} style={{ cursor: "pointer" }}>
                            <DeleteSvg />
                        </span>

                    </div>
                )
            }
        },
    ]

    const [loader, setLoader] = useState(false);
    const [allAlerts, setAllAlerts] = useState([]);
    const [pagination, setPagination] = useState({
        limit: 10,
        page: 1,
        total: 0,
        totalPages: 0
    })
    const [deleteAlert, setDeleteAlert] = useState(null);
    const [editAlert, setEditAlert] = useState(null);
    const [manageAlertsModal , setManageAlertsModal] = useState(false);

    const { model, series } = useSelector(
        (state) => state.filters
    );


    const getAllAlerts = async (pageParam) => {
        setLoader(true);
        try {
            const resp = await ExportApi.getAllPriceAlerts({ pageParam });
            if (resp?.data.success) {
                setLoader(false);
                setPagination(prev => ({
                    ...prev,
                    total: resp?.data?.data?.pagination?.total,
                    totalPages: resp?.data?.data?.pagination?.totalPages
                }));
                setAllAlerts(resp?.data?.data?.alerts || [])
            }
            else {
                setLoader(false);
                setAllAlerts([])
            }
        } catch (err) {
            setLoader(false);
            setAllAlerts([])
            console.error(err);
            toast.error("Something went wrong...");
        }
    }

    useEffect(() => {
        getAllAlerts(pagination?.page || 1)
    }, [pagination?.page]);


    const handlePageClick = (event, value) => {
        setPagination((prev) => ({ ...prev, page: value }));
    };

    const handleDeleteAlert = async (id) => {
        try {
            const resp = await ExportApi.deletePriceAlerts([id]);
            if (resp?.data.success) {
                setDeleteAlert(null);
                getAllAlerts(pagination?.page || 1)
                toast.success("Alert deleted successfully");
            }
            else {
                setDeleteAlert(null);
                toast.error("Something went wrong...");
            }
        } catch (err) {
            setDeleteAlert(null);
            console.error(err);
            toast.error("Something went wrong...");
        }
    }

       const handleUpdateAlert = async (alert) => {
        try {
            const resp = await ExportApi.updatePriceAlert(alert?._id , alert);
            if (resp?.data.success) {
                setEditAlert(null);
                getAllAlerts(pagination?.page || 1)
                toast.success("Alert updated successfully");
            }
            else {
                setEditAlert(null);
                toast.error("Something went wrong...");
            }
        } catch (err) {
            setDeleteAlert(null);
            console.error(err);
            toast.error("Something went wrong...");
        }
    }


    return (
        <div className="py-4">

            <div style={{ cursor: "pointer" }} className="d-flex justify-content-end align-items-end pb-2">
                <Button
                    // disabled={buttonLoading}
                    onClick={() => setManageAlertsModal(true)}
                    style={{ backgroundColor: "black", color: "#fff" }}
                    variant="primary"
                    // type="submit"
                    className="">
                    + Add Alerts
                </Button>
            </div>

            <SharedTable loader={loader} columns={columns} data={allAlerts} />

            <div className="py-2">
                {
                    pagination?.totalPages > 1 && (
                        <Stack spacing={2}>
                            <Pagination
                                className="order_pagination"
                                count={pagination?.totalPages || 0}
                                color="primary"
                                hidePrevButton
                                hideNextButton
                                page={pagination?.page}
                                onChange={handlePageClick}
                            />
                        </Stack>
                    )
                }
            </div>

            {/* Delete alert modal  */}
            <CustomModal
                show={deleteAlert !== null}
                handleClose={() => setDeleteAlert(null)}
                headerText={"Delete Alert"}
                closeButtonText={"Cancel"}
                actionButtonText={"Delete"}
                actionButton={() => {
                    handleDeleteAlert(deleteAlert)
                }}>
                <h4>
                    Are you sure you want to delete the selected Alert ?
                </h4>
            </CustomModal>

            {/* Edit aler modal  */}
            <CustomModal
                show={editAlert !== null}
                handleClose={() => setEditAlert(null)}
                headerText={"Update Alert"}
                closeButtonText={"Cancel"}
                actionButtonText={"Update"}
                actionButton={() => {
                    handleUpdateAlert(editAlert)
                }}
                actionButtonDisable={!editAlert?.series || !editAlert?.model || !editAlert?.price}>
                <div
                    style={{
                        maxHeight: "40vh",
                        overflowY: "auto",
                        overflowX: "hidden",
                        paddingRight: 5
                    }}
                >
                    <Row className="align-items-center mb-3 g-3">
                        {/* Series */}
                        <Col md={4}>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <Form.Select
                                    value={editAlert?.series ?? ""}
                                    onChange={(e) => setEditAlert({ ...editAlert, series: e.target.value })}
                                >
                                    <option value="">Select Series</option>
                                    {series.map((s) => (
                                        <option key={s} value={s}>{s}</option>
                                    ))}
                                </Form.Select>

                                <div style={{ height: "18px" }}>
                                    {(!editAlert?.series || editAlert?.series?.trim() == "") && (
                                        <small className="text-danger">Series is required</small>
                                    )}
                                </div>
                            </div>
                        </Col>

                        {/* Model */}
                        <Col md={4}>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <Form.Select
                                    value={editAlert?.model ?? ""}
                                    disabled={!editAlert?.series}
                                    onChange={(e) => setEditAlert({ ...editAlert, model: e.target.value })}
                                >
                                    <option value="ALL">ALL</option>
                                    {model.map((m) => (
                                        <option key={m} value={m}>{m}</option>
                                    ))}
                                </Form.Select>

                                <div style={{ height: "18px" }}>
                                    {(!editAlert?.model || editAlert?.model?.trim() == "") && (
                                        <small className="text-danger">Model is required</small>
                                    )}
                                </div>
                            </div>
                        </Col>

                        {/* Price */}
                        <Col md={3}>
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                <Form.Control
                                    type="number"
                                    placeholder="Target Price"
                                    min="1"
                                    value={editAlert?.price ?? ""}
                                    onChange={(e) => setEditAlert({ ...editAlert, price: e.target.value })}
                                />

                                <div style={{ height: "18px" }}>
                                    {(!editAlert?.price || editAlert?.price == 0) && (
                                        <small className="text-danger">Price is required</small>
                                    )}
                                </div>
                            </div>
                        </Col>

                    </Row>
                </div>
            </CustomModal>

              <CustomModal show={manageAlertsModal} handleClose={() => setManageAlertsModal(false)}>
                      <PriceAlertModalContent setShowPriceAlert={setManageAlertsModal} getAlerts={getAllAlerts} fromDashboard={true} />
                    </CustomModal>
        </div>
    )
}

export default ManageAlertsDashBoard;